module.exports = __webpack_public_path__ + "static/BoysAndGirlsClubLogo-1dd3bee49b37994357ff35138b56f2ed.jpg";